import { NavLink, useParams } from "react-router-dom";
import { Gavel, Heart, LayoutList, Package, TrendingUp } from "lucide-react";
import { useAuctions } from "../contexts/AuctionsContext";

export function BottomNav() {
    const { organizationSlug } = useParams<{ organizationSlug: string }>();
    const { liveCount } = useAuctions();

    const base = `/${organizationSlug}`;

    const navItems = [
        { to: `${base}/budrunder`, label: "Budrunder", icon: Gavel, count: liveCount },
        { to: `${base}/mine-bud`, label: "Mine bud", icon: TrendingUp },
        { to: `${base}/favoritter`, label: "Favoritter", icon: Heart },
        { to: `${base}/mine-kjop`, label: "Mine kjøp", icon: Package },
        { to: `${base}/mine-auksjoner`, label: "Auksjoner", icon: LayoutList },
    ];

    return (
        <nav
            className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-around border-t bg-white pt-2 pb-safe px-2 lg:hidden"
            style={{
                borderColor: "var(--border)",
                boxShadow: "0 -2px 10px rgba(0,0,0,0.05)"
            }}
        >
            {navItems.map(({ to, label, icon: Icon, count }) => (
                <NavLink
                    key={to}
                    to={to}
                    className={({ isActive }) =>
                        `flex flex-col items-center gap-1 px-2 py-1 transition-colors ${isActive ? "text-accent" : "text-muted-foreground"
                        }`
                    }
                >
                    <div className="relative">
                        <Icon className="h-5 w-5" />
                        {count !== undefined && count !== null && count > 0 && (
                            <span
                                className="absolute -right-2 -top-2 flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-bold text-white"
                                style={{ background: "var(--accent)" }}
                            >
                                {count}
                            </span>
                        )}
                    </div>
                    <span className="text-[10px] font-medium leading-none whitespace-nowrap">
                        {label.split(" ").pop()}
                    </span>
                </NavLink>
            ))}
        </nav>
    );
}
